import React, {useCallback, useEffect, useState} from 'react';
import {GridDivider} from "./styled";
import {
  Button,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  TextField,
  Typography,
  Divider,
  InputAdornment, CircularProgress
} from "@material-ui/core";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import {ClientFunding} from "./ClientFunding";
import {useClients} from "../../../hooks/useClients";
import {Client} from "../../../api/api";
import {useBoolean} from "../../../hooks/utils/useBoolean";


export const AdminFundingPage = () => {
  const { clients, loadClients, moreClients } = useClients(),
    [selected, select] = useState<Client>(),
      [disabled, on, off] = useBoolean(),
      [query, setQuery] = useState('')
  
  const loadMoreClients = useCallback(() => {
    on()
    moreClients(query).finally(off)
  }, [moreClients, off, on, query])

  useEffect(() => {
    on()
    loadClients(0, query).finally(off)
  }, [loadClients, off, on, query]);

  const onSelectClient = useCallback((client: Client) => async () => {
      if (client.clientPortfolioId) {
        select(client)
      }
    },
    []
  );

  return (
    <>
      <Grid container spacing={5}>
        <GridDivider item sm={12} md={4}>
          <TextField
              fullWidth
              margin='normal'
              label='Search'
              value={query}
              onChange={e => setQuery(e.target.value)}
              InputProps={{
                endAdornment: disabled && (
                    <InputAdornment position="end">
                      <CircularProgress color='secondary' size={24} />
                    </InputAdornment>
                )
              }}
          />
          <List>
            {clients?.map((c) => (
              <ListItem disabled={c.id === selected?.id || disabled} key={c.id} button onClick={onSelectClient(c)}>
                <ListItemText primary={c.name} />
                <ListItemIcon>
                  <ChevronRightIcon />
                </ListItemIcon>
              </ListItem>
            ))}
          </List>
          <Button fullWidth disabled={disabled} onClick={loadMoreClients}>
            more
          </Button>
        </GridDivider>
        <Grid item sm={12} md={8}>
          {selected && selected.clientPortfolioId && selected.id && (
              <>
                <Typography variant='h4'>{selected?.name}</Typography>
                <Divider variant='fullWidth' />
                <ClientFunding
                  portfolioId={selected.clientPortfolioId}
                  clientId={selected.id}
                />
              </>
          )}
        </Grid>
      </Grid>
    </>
  );
};
